// extracted by mini-css-extract-plugin
export var addToCartButton = "_ls-b";
export var arrowButtonContainer = "_ls-9";
export var arrowButtonIcon = "_ls-a";
export var carouselArrowButton = "_ls-6";
export var carouselElementContainer = "_ls-1";
export var left = "_ls-7";
export var productDisplayCarouselContainer = "_ls-0";
export var productTileContainer = "_ls-2";
export var productTileImage = "_ls-4";
export var productTileImageContainer = "_ls-3";
export var productTileTitle = "_ls-5";
export var right = "_ls-8";
export var sliderOverflow = "_ls-c";